import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/x-gray.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-712f4252")

_pushScopeId("data-v-712f4252")
const _hoisted_1 = {
  key: 0,
  class: "notification-card bg-white text-12px xxl:text-14px z-30 border border-gray-lp-400 px-4 py-5 shadow-md rounded-md"
}
const _hoisted_2 = { class: "flex justify-between items-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, " Update ", -1)
const _hoisted_4 = { class: "flex gap-x-6 justify-between items-start mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "flex gap-x-2 items-center"
}
const _hoisted_6 = { class: "text-green-lp-100 font-bold text-4xl" }
const _hoisted_7 = { class: "text-gray-lp-600 leading-tight" }
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "flex gap-x-2 items-center" }
const _hoisted_11 = { class: "text-red-lp-400 font-bold text-4xl" }
const _hoisted_12 = { class: "text-gray-lp-600 leading-tight" }
const _hoisted_13 = /*#__PURE__*/_createVNode("br", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.modelValue)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("img", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeNotification && _ctx.closeNotification(...args))),
            src: _imports_0,
            class: "cursor-pointer",
            alt: "x"
          })
        ]),
        _createVNode("div", _hoisted_4, [
          (_ctx.successSttPieces > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _createVNode("div", _hoisted_6, _toDisplayString(_ctx.successSttPieces), 1),
                _createVNode("div", _hoisted_7, [
                  _createTextVNode(_toDisplayString(_ctx.$t("stiDest.updateNotification.sttPieces")), 1),
                  _hoisted_8,
                  _createTextVNode(_toDisplayString(_ctx.$t("stiDest.updateNotification.success")), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.errorSttPieces > 0)
            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                _createVNode("div", _hoisted_10, [
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.errorSttPieces), 1),
                  _createVNode("div", _hoisted_12, [
                    _createTextVNode(_toDisplayString(_ctx.$t("stiDest.updateNotification.sttPieces")), 1),
                    _hoisted_13,
                    _createTextVNode(_toDisplayString(_ctx.$t("stiDest.updateNotification.failed")), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
})